<template>
  <div class="flex flex-col">
    <button
      class="warning-button ml-auto mr-4"
      @click="updateSyncDepartamentos()"
      v-if="!loading"
    >
      Sync Departamentos
    </button>
    <BaseSmallSpinner v-if="loading"></BaseSmallSpinner>
    <div class="overflow-x-auto" v-else>
      <table class="default-table text-center my-6">
        <thead>
          <th>ID</th>
          <th>CIA ID</th>
          <th>Departamento ID</th>
          <th>Código</th>
          <th>Nombre</th>
          <th>Main</th>
          <th>Server Port</th>
          <th>Server DB Name</th>
          <th>Server Username</th>
          <th>Server Password</th>
          <th>Server Endpoint</th>
          <th>Enabled Self Service</th>
        </thead>
        <tbody>
          <tr v-for="departamento in departamentos" :key="departamento.id">
            <td>{{ departamento.id }}</td>
            <td>{{ departamento.ciaId }}</td>
            <td>{{ departamento.departamentoId }}</td>
            <td>{{ departamento.codigo }}</td>
            <td>{{ departamento.nombre }}</td>
            <td>
              <span v-if="departamento.main === 1" class="text-green-600"
                >✓</span
              >
              <span v-else-if="departamento.main === 0" class="text-red-600"
                >✗</span
              >
              <span v-else class="text-gray-400">-</span>
            </td>
            <td>{{ departamento.serverPort || "-" }}</td>
            <td>{{ departamento.serverDbName || "-" }}</td>
            <td>{{ departamento.serverUsername || "-" }}</td>
            <td>
              <span v-if="departamento.serverPassword" class="text-gray-400"
                >***</span
              >
              <span v-else>-</span>
            </td>
            <td>{{ departamento.serverEndpoint || "-" }}</td>
            <td>
              <span
                v-if="departamento.enabledSelfService === 1"
                class="text-green-600"
                >✓</span
              >
              <span v-else class="text-red-600">✗</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { getDepartamentos, getSyncDepartamentos } from "@/api/Infoauto.js";
export default {
  name: "Departamentos",
  data() {
    return {
      departamentos: [],
      loading: true
    };
  },
  async mounted() {
    try {
      this.departamentos = await getDepartamentos();
    } catch (e) {
      console.log(e);
    }
    this.loading = false;
  },
  methods: {
    async updateSyncDepartamentos() {
      this.loading = true;
      try {
        this.departamentos = await getSyncDepartamentos();
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    }
  }
};
</script>
